
  <aside class="main-sidebar sidebar-light-blue elevation-4 custom-sidebar">
  
    <div class="logo_wraper">
      <div> Admin Panel </div>
    </div>
    <div class="sidebar">
      <nav class="mt-7">
        <ul class="nav nav-pills nav-sidebar flex-column">
  
  
          <!-- Block Master / Zone -->
          <li class="nav-item" *ngIf="role===-1||(permission?.blockRoute !== 1 && permission?.blockRoute !== undefined)">
            <a [routerLink]="['/blockROute']" class="nav-link" [class.active]="isRouteActive(['/blockROute'])">
              <mat-icon class="rel-5">grid_view</mat-icon>
              <span class="rels">Zone </span>
            </a>
          </li>

          <!-- Route Master -->
          <li class="nav-item" *ngIf="role===-1||permission?.routeMaster !== 1 && permission?.routeMaster !== undefined">
            <a [routerLink]="['/route']" class="nav-link" [class.active]="isRouteActive(['/route'])">
              <mat-icon class="rel-5">place</mat-icon>
              <span class="rels">Route</span>
            </a>
          </li>


          <!-- Document Master  -->
          <li class="nav-item" routerLinkActive="active" *ngIf="role=== -1 ||(permission?.masterDocuments !== 1 && permission?.masterDocuments !==undefined)">
            <a [routerLink]="['/documents']" class="nav-link" [class.active]="
                      isRouteActive(['/documents']) ">
              <mat-icon class="rel-5">description</mat-icon>
              <span class="rels">Document</span>
            </a>
          </li>


          <!-- Employee -->
          <li class="nav-item" *ngIf="role== -1||(permission?.employee != 1 && permission?.employee !==undefined)">
            <a [routerLink]="['/user']" class="nav-link" [class.active]="isRouteActive(['/user'])">
              <mat-icon class="rel-5">person</mat-icon>
              <span class="rels">Employee</span>
            </a>
          </li>

          <!-- Unit of Measurement (UOM) -->
          <li class="nav-item" *ngIf="role== -1||(permission?.uom != 1 && permission?.uom !==undefined)">
            <a [routerLink]="['/uom']" class="nav-link" [class.active]="isRouteActive(['/uom'])">
              <mat-icon class="rel-5">straighten</mat-icon>
              <span class="rels">UOM</span>
            </a>
          </li>

          <!-- Products -->
          <li class="nav-item" *ngIf="role== -1||(permission?.product != 1 && permission?.product !==undefined)">
            <a [routerLink]="['/product']" class="nav-link" [class.active]="isRouteActive(['/product'])">
              <mat-icon class="rel-5">inventory_2</mat-icon>
              <span class="rels">Products</span>
            </a>
          </li>
  
          <!-- Assignments -->
          <li class="nav-item" *ngIf="role== -1 ||(permission?.assignments != 1 && permission?.assignments !== undefined)">
            <a [routerLink]="['/assignment']" class="nav-link" [class.active]="isRouteActive(['/assignment'])">
              <mat-icon  class="rel-5">assignment</mat-icon>
              <span class="rels">Assignments</span>
            </a>
          </li>

          <!-- Approvals -->
          <li class="nav-item" *ngIf="role==-1||(permission?.approvals != 1 && permission?.approvals !== undefined)">
            <a [routerLink]="['/approvals']" class="nav-link" [class.active]="isRouteActive(['/approvals'])">
              <mat-icon  class="rel-5">check_circle</mat-icon>
              <span class="rels">Approvals</span>
            </a>
          </li>

          <!-- User Rights -->
          <li class="nav-item" routerLinkActive="active" *ngIf="role== -1">
            <a [routerLink]="['/rights']" class="nav-link" [class.active]="
                      isRouteActive(['/rights']) ">
              <mat-icon class="rel-5">admin_panel_settings</mat-icon>
              <span class="rels">User Rights</span>
            </a>
          </li>

          <!-- Hoarding Sites (Super Admin Only) -->
          <li class="nav-item" routerLinkActive="active" *ngIf="role == -1">
            <a [routerLink]="['/hoarding']" class="nav-link" [class.active]="isRouteActive(['/hoarding'])">
              <mat-icon class="rel-5">campaign</mat-icon>
              <span class="rels">Hoarding Sites</span>
            </a>
          </li>

          <!-- Reports -->
          <li class="nav-item" routerLinkActive="active" *ngIf="role==-1||(permission?.reports != 1 && permission?.reports !==undefined)">
            <a [routerLink]="['/reports']" class="nav-link" [class.active]="isRouteActive(['/reports'])">
              <mat-icon  class="rel-5">assessment</mat-icon>
              <span class="rels">Reports</span>
            </a>
          </li>

          <!-- Stores -->
          <li class="nav-item" routerLinkActive="active" *ngIf="role==-1||(permission?.store != 1 && permission?.store !==undefined)">
            <a [routerLink]="['/store']" class="nav-link" [class.active]="isRouteActive(['/store'])">
              <mat-icon  class="rel-5">storefront</mat-icon>
              <span class="rels">Stores</span>
            </a>
          </li>

          <!-- Setting -->
          <li class="nav-item" routerLinkActive="active" *ngIf="role===-1||(permission?.settings !== 1 && permission?.settings !==undefined)">
            <a [routerLink]="['/settings']" class="nav-link" [class.active]="isRouteActive(['/settings'])">
              <mat-icon  class="rel-5">settings</mat-icon>
              <span class="rels">Setting</span>
            </a>
          </li>

        </ul>
      </nav>
    </div>
  </aside>

  <div id="sidebar-overlay" (click)="closeMobileSidebar()"></div>